import { render, staticRenderFns } from "./EditAssignedRole.vue?vue&type=template&id=d8dc6e0a&scoped=true"
import script from "./EditAssignedRole.vue?vue&type=script&lang=js"
export * from "./EditAssignedRole.vue?vue&type=script&lang=js"
import style0 from "./EditAssignedRole.vue?vue&type=style&index=0&id=d8dc6e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dc6e0a",
  null
  
)

export default component.exports